exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".payment-failure .header{background-image:url(\"/assets/images/thank-you-bg.jpg\")}.payment-failure h3.content-heading,.payment-failure p.content-text{color:#1e2978}.payment-failure .content-text{padding:50px 0 0 120px}.payment-failure button{font-family:Nexa-Bold,sans pro,\"serif\";background-color:#020c7e;font-size:16px;color:#fff;padding:10px 30px 6px;margin-right:40px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/site/paymentFailure/paymentFailure.scss
// module id = 595
// module chunks = 0